export enum MATCH_DATA_APPLICATION_RENDER {
  INFO_PURCHASE = "INFO_PURCHASE",
  DOCUMENT = "DOCUMENT",
  DOCUMENT_ADMIN = "DOCUMENT_ADMIN",
  CHAT = "CHAT",
  BANK_CREDIT = "BANK_CREDIT",
  BANK_AGENT = "BANK_AGENT",
  BANK_CLIENT = "BANK_CLIENT",
  NOT_DATA = "NOT_DATA",
}
